module.exports = __webpack_public_path__ + "static/media/skeleton_gloves.b96cbe8d.png";